import React from "react";

// Components
import MasteryMap from "../../MasteryMap";
import OverallProgress from "../../OverallProgress";

const Journey = ({ courseId }) => {
  return (
    <div className='flex flex-col gap-4'>
      <OverallProgress isShow courseId={courseId} />

      {/* We will reenable mastery map when we figure out how we want it to work */}
      {/* <MasteryMap courseId={courseId} /> */}
    </div>
  )
}

export default Journey;
